import { apiSlice } from "@/shared/api"

import type { GetUserSettingsRequest, GetUserSettingsResponse } from "./types"

export const userSettingsApi = apiSlice.injectEndpoints({
  endpoints: builder => ({
    getUserSettings: builder.query<GetUserSettingsResponse, GetUserSettingsRequest>({
      query: () => "/api/v1/user/settings",
      providesTags: ["UserSettings"],
      keepUnusedDataFor: 60
    })
  })
})

export const { useGetUserSettingsQuery } = userSettingsApi
